import React, { useEffect, useState } from "react";
import "../css/registro.css";
import AppBar from "../Components/AppBar";
import ImagenReg from "../../SVG/RegistroCenfotec.svg";
import LoadingSpiner from "../../Components/LoadingSpiner";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  ObtenerDatosRegistro,
  VerificarPersonaPadron,
  verificarCorreo,
  verificarTelefono,
} from "../../redux/usuariosSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import autService from "../../services/authService";
import ReactSelect from "../../Components/ReactSelect";
import OperationStatus from "../../config/OperationStatus";
import WebApi from "../../Api/WebApi";
import Required from "../../Components/Required";
import { getLoginPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { useValidation } from "../../Hooks/useValidation";
import ValidationTest from "../../Components/ValidationTest";
import { Skeleton } from "antd";

import { StrapiError } from '../../Inicio/Pages/StrapiError';

export default function Registro() {
  const { locale } = useLocale();
  const [loginPage, setloginPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [hasError, setHasError] = useState(false);
  const { validation } = useValidation();
  const {
    register,
    trigger,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      dni: "",
      tipoDniId: "",
      nombres: "",
      alias: "",
      primerApellido: "",
      segundoApellido: "",
      contrasena: "",
      confirmarContrasenia: "",
      telefonoPrefijoId: 195,
      telefonoSufijo: "",
      correoElectronico: "",
      fechaNacimiento: "",
      consultadoEnPadron: false,
      paisProcedenciaId: null,
    },
  });
  const { registroModel } = useSelector((state) => state.usuarios);
  const [isDisabled, setIsDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tipoDniId = watch("tipoDniId", "");
  const dni = watch("dni", "");
  const fechaNacimiento = watch("fechaNacimiento", "");
  const contrasena = watch("contrasena");
  const [lista, setLista] = useState([]);
  const [paisProcedencia, setListaPaisProcedencia] = useState([]);

  useEffect(() => {
    dispatch(ObtenerDatosRegistro());
  }, [dispatch]);

  useEffect(() => {
    setValue("dni", dni.replace(/ /g, ""));
  }, [dni]);

  useEffect(() => {
    if (tipoDniId == 1 || tipoDniId == "") {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [tipoDniId]);

  useEffect(() => {
    if (registroModel && registroModel.paisesPrefijos) {
      let a = registroModel?.paisesPrefijos?.map((item, i) => {
        return {
          label: item.codigoArea + " " + item.paisNombre,
          value: item.id,
        };
      });
      setLista(a);
      let b = registroModel?.paises?.map((item, i) => {
        return { label: item.paisNombre, value: item.paisId };
      });
      setListaPaisProcedencia(b);
    }
  }, [registroModel?.paisesPrefijos]);

  const onSubmit = async (data) => {
    let o = {
      dni: data.dni,
      tipoDniId: tipoDniId,
      nombres: data.nombres,
      alias: data.alias,
      primerApellido: data.primerApellido,
      segundoApellido: data.segundoApellido,
      telefonoSufijo: data.telefonoSufijo,
      telefonoPrefijoId: data.telefonoPrefijoId,
      correoElectronico: data.correoElectronico,
      contrasena: data.contrasena,
      fechaNacimiento: data.fechaNacimiento,
      generoId: data.generoId,
      fotografiaId: null,
      consultadoEnPadron: data.consultadoEnPadron,
      paisProcedenciaId: data.paisProcedenciaId,
    };

    let result = await autService.register(o, dispatch);
    if (result.operationStatus === OperationStatus.SUCCESS) {
      let res = await autService.login(
        { correo: data.correoElectronico, contrasena: data.contrasena },
        dispatch
      );

      localStorage.setItem("token", res.result.token);
      localStorage.setItem(
        "refreshToken",
        JSON.stringify(res.result.refreshToken)
      );

      WebApi.setAuthToken(res.result.token);

      dispatch(verificarCorreo());
      dispatch(verificarTelefono());

      toast.success(result.message);
      navigate("/Verificar");
    } else {
      toast.error(result.message);
    }
  };

  const verificarPersona = async (a) => {
    a.preventDefault();
    var hasValue = await trigger(["dni", "tipoDniId"]);

    if (!hasValue) {
      return;
    }
    setLoading(true);
    let { payload } = await dispatch(VerificarPersonaPadron(dni));

    if (payload.operationStatus === OperationStatus.SUCCESS) {
      let p = payload.result;
      setValue("nombres", p.nombres);
      setValue("alias", p.alias);
      setValue("dni", p.cedula);
      setValue("primerApellido", p.primerApellido);
      setValue("segundoApellido", p.segundoApellido);
      setValue("fechaNacimiento", p.fechaNacimiento);
      setValue("consultadoEnPadron", true);
      setValue("paisProcedenciaId", 192);

      setLoading(false);
      setIsDisabled(true);
    } else {
      setLoading(false);
      toast.error(payload.message);
      setIsDisabled(false);
    }
  };
  const passwordVerify = (e) => {
    return contrasena === e;
  };

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setloginPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 5000);

    getLoginPage(locale)
      .then((res) => {
        clearTimeout(timeoutId);
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setloginPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch((error) => { 
        clearTimeout(timeoutId);
        if (!cancel) {
          setloginPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => { 
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale])

  if (isLoadingContent) {
    return (
      <div className="rootRegistro">
        <AppBar />
        <div className="contentRegistro">
          <div className="grid-container col-2 col-md col-sm-12">
            <div className="grid-item justify-self-center" style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
              <Skeleton.Input style={{ width: 300, height: 40 }} active />
              <Skeleton.Image style={{ width: 300, height: 300 }} active />
              <div className="list-background">
                <Skeleton active paragraph={{ rows: 3 }} />
                <Skeleton.Input style={{ width: '100%', height: 20 }} active />
                <Skeleton.Input style={{ width: '100%', height: 20 }} active />
                <Skeleton.Input style={{ width: '100%', height: 20 }} active />
              </div>
            </div>
            <div className="grid-item form-container justify-self-center">
              <Skeleton.Input style={{ width: 150, height: 30 }} active />
              <br />
              <div className="d-flex flex-gap-20">
                <div className="form-group">
                  <Skeleton.Input style={{ width: 200, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
                <div className="form-group">
                  <Skeleton.Input style={{ width: 150, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
              </div>
              <div className="d-flex flex-gap-20">
                <div className="form-group">
                  <Skeleton.Input style={{ width: 100, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
                <div className="form-group">
                  <Skeleton.Input style={{ width: 120, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
              </div>
              <div className="d-flex flex-gap-20">
                <div className="form-group">
                  <Skeleton.Input style={{ width: 140, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
                <div className="form-group">
                  <Skeleton.Input style={{ width: 160, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
              </div>
              <div className="form-group">
                <Skeleton.Input style={{ width: 120, height: 20 }} active />
                <Skeleton.Input style={{ width: '100%', height: 40 }} active />
              </div>
              <div className="d-flex flex-gap-20">
                <div className="form-group">
                  <Skeleton.Input style={{ width: 140, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
                <div className="form-group">
                  <Skeleton.Input style={{ width: 80, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
              </div>
              <div className="form-group">
                <Skeleton.Input style={{ width: 150, height: 20 }} active />
                <Skeleton.Input style={{ width: '100%', height: 40 }} active />
              </div>
              <div className="d-flex flex-gap-20">
                <div className="form-group">
                  <Skeleton.Input style={{ width: 100, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
                <div className="form-group">
                  <Skeleton.Input style={{ width: 160, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
              </div>
              <div className="form-group">
                <Skeleton.Input style={{ width: 120, height: 20 }} active />
                <div className="d-flex flex-gap-20">
                  <Skeleton.Input style={{ width: 100, height: 40 }} active />
                  <Skeleton.Input style={{ width: 150, height: 40 }} active />
                </div>
              </div>
              <Skeleton.Button style={{ width: 150, height: 40 }} active />
              <Skeleton.Input style={{ width: 200, height: 20 }} active />
            </div>
          </div>
        </div>
        <ValidationTest />
      </div>
    );
  }else if (hasError && locale === 'en') {
    return <StrapiError 
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setloginPage(null);
      }}
    />
  }

  return (
    <div className="rootRegistro">
      <AppBar />
      <div className="contentRegistro">
        <div className="grid-container col-2 col-md col-sm-12 ">
          <div
            className="grid-item justify-self-center"
            style={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h1>{loginPage?.signupPage?.title || "CENFOTEC Admisiones"}</h1>
            <img
              className="imgRegistro"
              src={ImagenReg}
              alt="Imagen de Registro"
            />
            <div className="list-background">
              <p>
                {loginPage?.signupPage?.description_paragraph || "Antes de iniciar, le recomendamos tener listos los siguientes documentos en formato digital (.jpg, .png, .pdf o .docx), ya que serán requeridos durante el proceso:"}
              </p>
              <ul>
                <li>
                  {loginPage?.signupPage?.description_bulletO || "1. Documento de identificación (Cédula, DIMEX o Pasaporte). Debe ser claro, legible y por ambas caras."}
                </li>
                <li>
                  {loginPage?.signupPage?.description_bulletT || "2. Fotografía tipo retrato. Rostro visible, sin gafas oscuras, gorra o sombrero. Fondo claro."}
                </li>
                <li>
                  {loginPage?.signupPage?.description_bulletTR || "3. Título académico* (según el programa al que desea ingresar):"}
                  <ul className="list-decor">
                    <li>
                      {loginPage?.signupPage?.description_bulletTR_O || "Para Maestrías: Título de Bachiller en Educación Media y Título de Bachiller o Licenciatura universitaria"}
                    </li>
                    <li>
                      {loginPage?.signupPage?.description_bulletTR_T || "Para Bachillerato y Programas Profesionales: Título de Bachiller en Educación Media."}
                    </li>
                    <li>
                      {loginPage?.signupPage?.description_bulletTR_TR || "Para Técnicos: Título de Educación General Básica (noveno año), o Título de Bachiller en Educación Media (validar requisito con el Asesor). *Si aún no cuenta con el título oficial, puede adjuntar una certificación o constancia temporal en el espacio correspondiente."}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>

          <div className="grid-item form-container justify-self-center">
            <h2>{loginPage?.signupPage?.subtitle || "Registro"}</h2>
            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="d-flex flex-gap-20">
                <div className="form-group">
                  <label>{loginPage?.signupPage?.typeID || "Tipo de documento de identificación"}</label>
                  <Required />

                  <select
                    className="form-control"
                    {...register("tipoDniId", { required: validation?.required_field || "Campo requerido" })}
                  >
                    <option value="">{loginPage?.signupPage?.select_option || "Seleccione"}</option>
                    {registroModel?.tiposDni?.map((item, i) => {
                      return (
                        <option key={i} value={item.tipoDniId}>
                          {item.tipoDniNombre}
                        </option>
                      );
                    })}
                  </select>
                  {errors.tipoDniId && (
                    <p className="error">{errors.tipoDniId.message}</p>
                  )}
                </div>

                <div className="form-group">
                  <label>{loginPage?.signupPage?.numberID || "No. de documento"}</label>
                  <Required />

                  <div className="registerFlex">
                    <div>
                      <input
                        id="inputCed"
                        {...register("dni", { required: validation?.required_field || "Campo requerido" })}
                        type="text"
                      ></input>
                    </div>
                    {tipoDniId == 1 && (
                      <>
                        <button id="btnConfirm" onClick={verificarPersona}>
                          {loginPage?.signupPage?.register || "Confirmar"}
                        </button>
                        {loading && (
                          <div className="ml-1">
                            <LoadingSpiner
                              styles={{
                                width: "25px",
                                height: "25px",
                                border: "6px solid #bbbbbb",
                                borderTop: "6px solid #035cc9",
                              }}
                            />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  {errors.dni && <p className="error">{errors.dni.message}</p>}
                </div>
              </div>

              <div className="d-flex flex-gap-20">
                <div className="form-group">
                  <label>{loginPage?.signupPage?.Name || "Nombre(s)"}</label>
                  <Required />
                  <input
                    className="form-control"
                    type="text"
                    disabled={isDisabled}
                    {...register("nombres", {
                      required: validation?.required_field || "Campo requerido",
                    })}
                  />
                  {errors.nombres && (
                    <p className="error">{errors.nombres.message}</p>
                  )}
                </div>
                <div className="form-group">
                  <label>{loginPage?.signupPage?.nickname || "Conocido como"}</label>
                  <input
                    className="form-control"
                    type="text"
                    disabled={isDisabled}
                    {...register("alias")}
                  />
                  {errors.alias && (
                    <p className="error">{errors.alias.message}</p>
                  )}
                </div>
              </div>
              <div className="d-flex flex-gap-20">
                <div className="form-group">
                  <label>{loginPage?.signupPage?.firstLastName || "Primer apellido"}</label>
                  <Required />
                  <input
                    className="form-control"
                    type="text"
                    disabled={isDisabled}
                    {...register("primerApellido", {
                      required: validation?.required_field || "Campo requerido",
                    })}
                  />
                  {errors.primerApellido && (
                    <p className="error">{errors.primerApellido.message}</p>
                  )}
                </div>
                <div className="form-group">
                  <label>{loginPage?.signupPage?.secondLastName || "Segundo apellido"}</label>
                  <Required />
                  <input
                    className="form-control"
                    type="text"
                    disabled={isDisabled}
                    {...register("segundoApellido", {
                      required: validation?.required_field || "Campo requerido",
                    })}
                  />
                  {errors.segundoApellido && (
                    <p className="error">{errors.segundoApellido.message}</p>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label>{loginPage?.signupPage?.country || "Pais procedencia"}</label>
                <Required />
                <ReactSelect
                  name="paisProcedenciaId"
                  control={control}
                  lista={paisProcedencia}
                  rules={{ required: validation?.required_field || "Campo requerido" }}
                  disabled={isDisabled}
                />
                {errors.paisProcedenciaId && (
                  <p className="error">{errors.paisProcedenciaId.message}</p>
                )}
              </div>
              <div className="d-flex flex-gap-20">
                <div className="form-group">
                  <label>{loginPage?.signupPage?.birthdate || "Fecha de nacimiento"}</label>
                  <Required />
                  <input
                    className="form-control"
                    type="date"
                    disabled={isDisabled && fechaNacimiento != null}
                    {...register("fechaNacimiento", {
                      required: validation?.required_field || "Campo requerido",
                    })}
                  />
                  {errors.fechaNacimiento && (
                    <p className="error">{errors.fechaNacimiento.message}</p>
                  )}
                </div>
                <div className="form-group">
                  <label>{loginPage?.signupPage?.gender || "Género"}</label>
                  <Required />

                  <select
                    className="form-control"
                    {...register("generoId", { required: validation?.required_field || "Campo requerido" })}
                  >
                    <option value="">{loginPage?.signupPage?.select_option || "Seleccione"}</option>
                    {registroModel?.generos?.map((item, i) => {
                      return (
                        <option key={i} value={item.generoId}>
                          {item.generoNombre}
                        </option>
                      );
                    })}
                  </select>
                  {errors.generoId && (
                    <p className="error">{errors.generoId.message}</p>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label>{loginPage?.signupPage?.email || "Correo electrónico"}</label>
                <Required />

                <input
                  className="form-control"
                  autoComplete="email"
                  type="email"
                  {...register("correoElectronico", {
                    required: validation?.required_field || "Campo requerido",
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: validation?.invalid_email || "Escriba un correoElectronico valido",
                    },
                  })}
                />
                {errors.correoElectronico && (
                  <p className="error">{errors.correoElectronico.message}</p>
                )}
              </div>

              <div className="d-flex flex-gap-20">
                <div className="form-group">
                  <label>{loginPage?.signupPage?.password || "Contraseña"}</label>
                  <Required />
                  <input
                    className="form-control"
                    autoComplete="new-password"
                    type="password"
                    {...register("contrasena", { required: validation?.required_field || "Campo requerido" })}
                  />
                  {errors.contrasena && (
                    <p className="error">{errors.contrasena.message}</p>
                  )}
                </div>
                <div className="form-group">
                  <label>{loginPage?.signupPage?.confirm_password || "Confirmar contraseña"}</label>
                  <Required />

                  <input
                    className="form-control"
                    type="password"
                    autoComplete="new-password"
                    {...register("confirmarContrasenia", {
                      required: validation?.required_field || "Campo requerido",
                      validate: passwordVerify,
                    })}
                  />
                  {errors.confirmarContrasenia && (
                    <p className="error">
                      {errors.confirmarContrasenia.message}
                    </p>
                  )}
                  {errors?.confirmarContrasenia?.type === "validate" && (
                    <p className="error">{validation?.password_mismatch || "Las contraseñas no coinciden"}</p>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label>{loginPage?.signupPage?.number_phone || "Teléfono móvil"}</label>
                <Required />

                <div className="d-flex flex-gap-20">
                  <div className="select-container">
                    <ReactSelect
                      name="telefonoPrefijoId"
                      control={control}
                      lista={lista}
                      rules={{ required: validation?.required_field || "Campo requerido" }}
                    />
                  </div>
                  <input
                    id="inputTel"
                    className="form-control"
                    type="text"
                    {...register("telefonoSufijo", {
                      required: validation?.required_field || "Campo requerido",
                    })}
                  />
                </div>

                {errors.telefonoPrefijoId && (
                  <p className="error">{errors.telefonoPrefijoId.message}</p>
                )}
                {errors.telefonoSufijo && (
                  <p className="error">{errors.telefonoSufijo.message}</p>
                )}
              </div>
              <input type="submit" id="btnRegistro" value={loginPage?.signupPage?.signup_button || "Registrarse"} />
            </form>
            <h5>
              {loginPage?.signupPage?.label_haveAnAccount || "¿Ya tienes una cuenta?"} <Link to="/Login">{loginPage?.signupPage?.enter_link || "Ingresa"}</Link>
            </h5>
          </div>
        </div>
      </div>
      
      {/* Componente de prueba para validaciones - REMOVER EN PRODUCCIÓN */}
      <ValidationTest />
    </div>
  );
}
